module.exports = __webpack_public_path__ + "img/duplicate_icon.d89860f8.svg";